var AccessPopover;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

export default AccessPopover = Vue.extend({
  components: {
    'Popover': Popover
  },
  props: {
    accessesList: {
      type: Array
    },
    admin: {
      type: Object
    },
    access: {
      type: Object
    }
  },
  template: `<div class="user-info access">
  <Popover  class="bottom access-popover"
            customClass="administrator-access-popover"
            :loadContent="true"
            size="small"
            ref="popover">
    <template slot="trigger">
      <span class="mr-1">{{ access.name }}</span>
      <i class="slp-chevron-down"></i>
    </template>
    <template slot="content">
      <div class="list">
        <template v-for="item in accessesList">
          <div class="list-item" :class="_getAccessClass(item)" @click.stop="accessChange(item)">{{item.name}}</div>
        </template>
      </div>
    </template>
  </Popover>
</div>`,
  methods: {
    accessChange: function(access) {
      this.$refs.popover.close();
      return this.$emit('adminAccessChanged', {
        admin: this.admin,
        access: access
      });
    },
    _getAccessClass: function(access) {
      return {
        selected: access.id === this.access.id
      };
    }
  }
});
